import React from "react";
import { styled } from "@mui/material";

import { Header } from "./Header";
import { AppRouting } from "./AppRouting";
import { Footer } from "./Footer";
import { SplashScreen } from "#components/App/SplashScreen";
import { useMatomo } from "@iva/matomo-tracker-react";
import { useLocation } from "react-router-dom";

const MainBody = styled("main")(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
}));

const App = () => {
    const { trackPageView } = useMatomo();
    let location = useLocation();

    React.useEffect(() => {
        trackPageView();
    }, [location]);

    return (
        <SplashScreen>
            <Header />
            <MainBody>
                <AppRouting />
            </MainBody>
            <Footer />
        </SplashScreen>
    );
};

export default App;
